import { makeAutoObservable } from "mobx"
import { getStockDetailData } from "../../../modules/quote/web"
import { getPageType, PageType } from "../../shared/pagetype"
import { ChartType } from "../../shared/utils"

class Store {
  constructor() {
    if (getPageType() == PageType.英股) {
      // || getPageType() == PageType.日本 || getPageType() == PageType.韩国 || getPageType() == PageType.台湾
      makeAutoObservable(this)
      this.init()
    }
  }

  StockDetail: any = undefined

  chartType = ChartType.分时

  chart_mouse_move_data: any = null

  async init() {
    this.getData()

    setInterval(() => {
      this.getData()
    }, 30 * 1000)
  }

  // 必备参数：f177、f292、f734
  async getData() {
    let data = await getStockDetailData(window.quotedata.quotecode, "f19,f20,f39,f40,f43,f44,f45,f46,f47,f48,f50,f59,f60,f107,f116,f117,f152,f153,f164,f167,f168,f169,f170,f174,f175,f177,f182,f292,f301,f530,f734")
    if (data) {
      this.setStockDetail(data)
    }
  }

  setStockDetail(StockDetail: any) {
    this.StockDetail = StockDetail
  }

  setChartType(chartType: ChartType) {
    this.chartType = chartType
  }

  setChartMouseMoveData(chart_mouse_move_data: any) {
    this.chart_mouse_move_data = chart_mouse_move_data
  }
}

export const store = new Store()
